module.exports = __webpack_public_path__ + "img/imagen4.9c63d2a1.png";